
import * as s3ProviderRuntime$ZLbPndhTRZ from '/app/providers/img-provider.ts'
import * as localRuntime$ZLbPndhTRZ from '/app/providers/img-provider.ts'
import * as ipxRuntime$bLXOQnc2jF from '/app/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['s3Provider']: { provider: s3ProviderRuntime$ZLbPndhTRZ, defaults: {"baseURL":"https://images.byhours.com/img-web"} },
  ['local']: { provider: localRuntime$ZLbPndhTRZ, defaults: {"baseURL":"https://cms.byhours.com"} },
  ['ipx']: { provider: ipxRuntime$bLXOQnc2jF, defaults: {} }
}
        